import { Component, ElementRef, EventEmitter, HostListener, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { BcbService } from 'src/app/services/bcb/bcb.service';
import { BcbLpp, ProduitFromCodeLpp } from 'src/app/utils/interfaces/new/bcb-lpp.interface';
import { environment } from 'src/environments/environment';

interface NgSelect {
  id: string;
  libelle: string
}

export interface ProduitDispositifMedical {
  libelle: string;
  codeLpp: string;
  isLocation: boolean;
  acl?: string;
  ref13?: string;
  libelleMarque?: string;
}

@Component({
  selector: 'app-recherche-dispositif-medical',
  templateUrl: './recherche-dispositif-medical.component.html',
  styleUrls: [
    './recherche-dispositif-medical.component.scss',
    '../modal.fragment.scss'
  ]
})
export class RechercheDispositifMedicalComponent implements OnInit, OnDestroy {

  @ViewChild('modalBody') public modalBody: ElementRef;
  @ViewChild('outsideModal') public outsideModal: ElementRef;

  @Output() public closeEmitter = new EventEmitter();

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    if (!environment.closeModalOnClickOutside) {
      return;
    }

    if (!this.modalBody.nativeElement.contains(event.target) && this.outsideModal.nativeElement.contains(event.target)) {
      this.closeModal();
    }
  }

  public formGroup: FormGroup;
  public listLppTemplate: Array<NgSelect> = [];
  public listLpp: Array<BcbLpp> = [];
  public listProduitsTemplate: Array<NgSelect> = [];
  public listProduits: Array<ProduitFromCodeLpp> = [];
  public isLppSearchResultMessageDisplay = false;
  public isProduitSearchResultMessageDisplay = false;
  private _rechecherLppSub: Subscription;
  private _rechecherProduitsSub: Subscription;

  constructor(
    private _formBuilder: FormBuilder,
    private _bcbSrv: BcbService,
  ) { }

  ngOnInit(): void {
    this.formGroup = this._formBuilder.group({
      libelleLpp: [''],
      codeLpp: [undefined, Validators.required],
      idProduit: [undefined]
    });

    this._rechecherLppSub = this.formGroup.get('libelleLpp').valueChanges.pipe(debounceTime(400)).subscribe(async v => {
      await this.rechercherLpp(v);
    });

    this._rechecherProduitsSub = this.formGroup.get('codeLpp').valueChanges.pipe(debounceTime(400)).subscribe(async v => {
      await this.rechercherProduits(v);
    });
  }

  ngOnDestroy(): void {
    if (this._rechecherLppSub) {
      this._rechecherLppSub.unsubscribe();
    }

    if (this._rechecherProduitsSub) {
      this._rechecherProduitsSub.unsubscribe();
    }
  }

  public isListProduitsExists(): boolean {
    return this.listProduitsTemplate && this.listProduitsTemplate.length > 0;
  }

  public getListProduits(): Array<NgSelect> {
    return this.listProduitsTemplate;
  }

  public validerSelection(): void {
    const lpp = this.listLpp.find(l => l.code === this.formGroup.get('codeLpp').value);
    const produit = this.formGroup.get('idProduit')?.value ? this.listProduits.find(l => l.idProduit.toString() === this.formGroup.get('idProduit').value) : undefined;

    this.closeModal({
      libelle: lpp.libelle,
      codeLpp: lpp.code,
      isLocation: lpp.typePrestation === 'Location',
      acl: produit?.codeAcl,
      ref13: produit?.ref13,
      libelleMarque: produit?.libelleMarque,
    });
  }

  public async rechercherLpp(libelle: string): Promise<void> {
    if (libelle && libelle !== '') {
      this.listLpp = [];
      this.listProduits = [];
      this.listLppTemplate = [];
      this.listProduitsTemplate = [];
      this.listLpp = await this._bcbSrv.rechercheLpp(libelle);
      if (this.listLpp) {
        this.listLppTemplate = this.listLpp.map<NgSelect>(lpp => { return { id: lpp.code, libelle: lpp.libelle } });
      }

      if (this.listLppTemplate.length > 0) {
        this.isLppSearchResultMessageDisplay = false;
      } else {
        this.isLppSearchResultMessageDisplay = true;
      }
    } else if (libelle === '') {
      // DO SOMETHING...
      this.listLpp = [];
      this.listProduits = [];
      this.listLppTemplate = [];
      this.listProduitsTemplate = [];
      this.isLppSearchResultMessageDisplay = false;
    }
    this.isProduitSearchResultMessageDisplay = false;
  }

  public async rechercherProduits(codeLpp: any): Promise<void> {
    if (codeLpp) {
      this.listProduits = [];
      this.listProduitsTemplate = [];
      this.listProduits = await this._bcbSrv.rechercheProduitByCodeLpp(codeLpp);
      if (this.listProduits) {
        this.listProduitsTemplate = this.listProduits.map<NgSelect>(p => { return { id: p.idProduit.toString(), libelle: p.libelle } });
      }

      if (this.listProduitsTemplate.length > 0) {
        this.isLppSearchResultMessageDisplay = false;
      } else {
        this.isLppSearchResultMessageDisplay = true;
      }
    } else {
      // DO SOMETHING...
      this.listProduits = [];
      this.listProduitsTemplate = [];
      this.isProduitSearchResultMessageDisplay = false;
    }
  }

  public closeModal(dm?: ProduitDispositifMedical): void {
    if (dm) {
      this.closeEmitter.emit(dm);
    } else {
      this.closeEmitter.emit(null);
    }
  }

}
